import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import { Organization } from '../../../organizations/types/organization.type';
import { OrganizationOrderOwner } from '../../utils/build-organization-order-payload.util';

type Props = {
  organization: Organization;
  selectedOwner: OrganizationOrderOwner | null;
  onOwnerChange: (owner: OrganizationOrderOwner | null) => void;
};

export function buildOwnerOptions(organization: Organization): OrganizationOrderOwner[] {
  const contactOption: OrganizationOrderOwner = {
    id: organization.contact.id,
    firstname: organization.contact.firstname,
    lastname: organization.contact.lastname,
    phone: organization.contact.phoneNumber,
  };

  const memberOptions = organization.members
    .filter((member) => member.id !== organization.contact.id)
    .map((member) => ({
      id: member.id,
      firstname: member.firstname,
      lastname: member.lastname,
      phone: member.phone || undefined,
    }));

  return [contactOption, ...memberOptions];
}

export function OrganizationOwnerSelect({ organization, selectedOwner, onOwnerChange }: Props) {
  const options = buildOwnerOptions(organization);

  return (
    <Autocomplete
      value={selectedOwner}
      onChange={(_, newValue) => onOwnerChange(typeof newValue === 'string' ? null : newValue)}
      options={options}
      getOptionLabel={(option) =>
        typeof option === 'string' ? option : `${option.firstname} ${option.lastname}`
      }
      getOptionSelected={(option, value) => option.id === value.id}
      renderInput={(params) => <TextField {...params} label="Commande pour" variant="outlined" />}
    />
  );
}
